package com.arenaproplay.admin.ui.components.admin

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import com.arenaproplay.admin.domain.admin.Period
import com.arenaproplay.admin.ui.theme.AppColors
import com.arenaproplay.admin.ui.theme.bodySMedium
import com.arenaproplay.admin.ui.utils.sBorderRadius
import org.jetbrains.compose.web.css.*

@Composable
fun PeriodSelector(
    selected: Period,
    modifier: Modifier = Modifier,
    includeDay: Boolean = false,
    options: List<Period>? = null,
    onSelect: (Period) -> Unit
) {
    val opts = options ?: buildList {
        if (includeDay) add(Period.DAY)
        add(Period.WEEK)
        add(Period.MONTH)
        add(Period.YEAR)
    }
    Row(
        modifier
            .sBorderRadius(999)
            .styleModifier {
                property("background", "#101828")
                property("border", "1px solid #1C2634")
                property("padding", "3px")
            },
        verticalAlignment = Alignment.CenterVertically
    ) {
        opts.forEach { p ->
            PeriodChip(periodLabel(p), selected == p) { onSelect(p) }
        }
    }
}

private fun periodLabel(p: Period): String = when (p) {
    Period.DAY -> "Today"
    Period.WEEK -> "Week"
    Period.MONTH -> "Month"
    Period.YEAR -> "Year"
    Period.ALL -> "All time"
}

@Composable
private fun PeriodChip(label: String, active: Boolean, onClick: () -> Unit) {
    Box(
        Modifier
            .padding(leftRight = 14.px, topBottom = 6.px)
            .sBorderRadius(999)
            .cursor(Cursor.Pointer)
            .styleModifier {
                if (active) {
                    // Active: light ink chip, dark text (Night Arena inverted)
                    property("background", "#F0F4FC")
                }
                property("transition", "all 180ms ease")
            }
            .onClick { onClick() }
    ) {
        SpanText(
            label,
            Modifier
                .bodySMedium()
                .color(if (active) Color("#05080F") else AppColors.Muted)
                .styleModifier {
                    if (active) property("font-weight", "600")
                }
        )
    }
}
